export default {
  "content": "<path d=\"M3 17.96V21c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15l10.92-10.91-3.75-3.75L3.15 17.6c-.1.1-.15.22-.15.36zM20.71 7.54a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#333",
    "viewBox": "0 0 24 24"
  }
};